import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import { Grid, Typography, Snackbar } from '@material-ui/core';
import Button from '../../../../core/Button';
import DataGrid from '../../../../data/Grid';
import request from '../../../../utils/request';

var SynchronizationLog = function SynchronizationLog() {
  React.useEffect(function () {
    document.title = 'Settings � Synchronization Log � Ecrion';
  }, []);

  var _React$useState = React.useState({
    open: false,
    count: 0
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var handleClose = function handleClose() {
    setState(_objectSpread({}, state, {
      open: false
    }));
  };

  React.useEffect(function () {
    var timer = setTimeout(function () {
      setState(_objectSpread({}, state, {
        count: state.count + 1
      }));
    }, 3000); // this will clear Timeout when component unmounts

    return function () {
      clearTimeout(timer);
    };
  }, [state.count]);
  return React.createElement(React.Fragment, null, React.createElement(Grid, {
    key: state.count,
    container: true,
    direction: "row"
  }, React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(Typography, {
    variant: "h6"
  }, "Synchronization Log"), React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, React.createElement(Button, {
    style: {
      position: 'relative',
      bottom: '32px',
      paddingRight: '16px'
    },
    icon: "refresh",
    onClick: function onClick() {
      request({
        url: '/backend/synchronize',
        method: 'POST'
      }).then(function () {
        setState(_objectSpread({}, state, {
          open: !state.open
        }));
      });
    }
  }, "Synchronize Now")), React.createElement(React.Fragment, null, React.createElement(Grid, {
    item: true
  }, React.createElement(DataGrid, {
    id: "synchronization-log",
    dataType: "syncLog",
    dataProps: {},
    viewProps: {
      hideModeSwitcher: true
    },
    styles: {
      elevation: 0,
      hideBorder: true
    }
  }))))), React.createElement(Snackbar, {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    open: state.open,
    onClose: handleClose,
    ContentProps: {
      'aria-describedby': 'message-id'
    },
    message: React.createElement("span", {
      id: "message-id"
    }, "Synchronization started"),
    autoHideDuration: 3000
  }));
};

export default SynchronizationLog;